export default __webpack_public_path__ + "media/pro/checkmark-2c6a9dea.svg";